/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Box, Text } from '@sonyged/proc-ui';
import { css } from '@styled-system/css';

export const TabBar = styled(Box)(
  css({
    display: 'flex',
    height: [38, 38, 48],
    borderBottomColor: 'secondary30',
    borderBottomWidth: 2,
    borderBottomStyle: 'solid',
    '> * + *': {
      ml: [7, 7, 9],
    },
  })
);

type TabBarItemProps = {
  active?: boolean,
  onClick: Function,
  title: string,
};
export const TabBarItem = function(props: TabBarItemProps) {
  let { active, title, onClick } = props;
  return (
    <TabBarItemContainer className="proc-button-se" active={active} onClick={onClick}>
      <TabBarItemLabel active={active}>{title}</TabBarItemLabel>
    </TabBarItemContainer>
  );
};

const TabBarItemContainer = styled(Box)(
  css({
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: 'secondary30',
    borderWidth: [2],
    borderBottomWidth: 0,
    borderStyle: 'solid',
    borderTopLeftRadius: [18, 18, 24],
    borderTopRightRadius: [18, 18, 24],
    cursor: 'pointer',
  }),
  ({ active }) => active && css({ bg: 'secondary30' })
);

const TabBarItemLabel = styled(Text)(
  css({
    color: 'white',
    fontSize: [16, 16, 20],
  }),
  ({ active }) => active && css({ color: 'gray80' })
);
